/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { centerNoticeControllerCreate } from '../fn/center-notice/center-notice-controller-create';
import { CenterNoticeControllerCreate$Params } from '../fn/center-notice/center-notice-controller-create';
import { centerNoticeControllerDelete } from '../fn/center-notice/center-notice-controller-delete';
import { CenterNoticeControllerDelete$Params } from '../fn/center-notice/center-notice-controller-delete';
import { centerNoticeControllerFindAll } from '../fn/center-notice/center-notice-controller-find-all';
import { CenterNoticeControllerFindAll$Params } from '../fn/center-notice/center-notice-controller-find-all';
import { centerNoticeControllerFindById } from '../fn/center-notice/center-notice-controller-find-by-id';
import { CenterNoticeControllerFindById$Params } from '../fn/center-notice/center-notice-controller-find-by-id';
import { centerNoticeControllerSearchCursor } from '../fn/center-notice/center-notice-controller-search-cursor';
import { CenterNoticeControllerSearchCursor$Params } from '../fn/center-notice/center-notice-controller-search-cursor';
import { centerNoticeControllerSearchOffset } from '../fn/center-notice/center-notice-controller-search-offset';
import { CenterNoticeControllerSearchOffset$Params } from '../fn/center-notice/center-notice-controller-search-offset';
import { centerNoticeControllerUpdate } from '../fn/center-notice/center-notice-controller-update';
import { CenterNoticeControllerUpdate$Params } from '../fn/center-notice/center-notice-controller-update';
import { centerNoticeControllerUpdateOrder } from '../fn/center-notice/center-notice-controller-update-order';
import { CenterNoticeControllerUpdateOrder$Params } from '../fn/center-notice/center-notice-controller-update-order';
import { CenterNoticeDto } from '../models/center-notice-dto';
import { CenterNoticeSearchResponseDto } from '../models/center-notice-search-response-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { parentCenterNoticeControllerCountByParent } from '../fn/center-notice/parent-center-notice-controller-count-by-parent';
import { ParentCenterNoticeControllerCountByParent$Params } from '../fn/center-notice/parent-center-notice-controller-count-by-parent';
import { parentCenterNoticeControllerFindById } from '../fn/center-notice/parent-center-notice-controller-find-by-id';
import { ParentCenterNoticeControllerFindById$Params } from '../fn/center-notice/parent-center-notice-controller-find-by-id';
import { parentCenterNoticeControllerSearchCursor } from '../fn/center-notice/parent-center-notice-controller-search-cursor';
import { ParentCenterNoticeControllerSearchCursor$Params } from '../fn/center-notice/parent-center-notice-controller-search-cursor';

@Injectable({ providedIn: 'root' })
export class CenterNoticeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerNoticeControllerFindAll()` */
  static readonly CenterNoticeControllerFindAllPath = '/api/center-notice/center';

  /**
   * 센터 공지사항 전체 조회.
   *
   * 센터 공지사항 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerFindAll$Response(params?: CenterNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterNoticeDto>>> {
    return centerNoticeControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 전체 조회.
   *
   * 센터 공지사항 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerFindAll(params?: CenterNoticeControllerFindAll$Params, context?: HttpContext): Observable<Array<CenterNoticeDto>> {
    return this.centerNoticeControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterNoticeDto>>): Array<CenterNoticeDto> => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerCreate()` */
  static readonly CenterNoticeControllerCreatePath = '/api/center-notice/center';

  /**
   * 센터 공지사항 생성.
   *
   * 센터 공지사항을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerCreate$Response(params: CenterNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
    return centerNoticeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 생성.
   *
   * 센터 공지사항을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerCreate(params: CenterNoticeControllerCreate$Params, context?: HttpContext): Observable<CenterNoticeDto> {
    return this.centerNoticeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeDto>): CenterNoticeDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerSearchOffset()` */
  static readonly CenterNoticeControllerSearchOffsetPath = '/api/center-notice/center/search/offset';

  /**
   * 센터 공지사항 오프셋 기반 조회.
   *
   * 센터 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerSearchOffset$Response(params: CenterNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return centerNoticeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 오프셋 기반 조회.
   *
   * 센터 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerSearchOffset(params: CenterNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.centerNoticeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerSearchCursor()` */
  static readonly CenterNoticeControllerSearchCursorPath = '/api/center-notice/center/search/cursor';

  /**
   * 센터 공지사항 커서 기반 조회.
   *
   * 센터 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerSearchCursor$Response(params: CenterNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return centerNoticeControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 커서 기반 조회.
   *
   * 센터 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerSearchCursor(params: CenterNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.centerNoticeControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerFindById()` */
  static readonly CenterNoticeControllerFindByIdPath = '/api/center-notice/center/{id}';

  /**
   * 센터 공지사항 ID 기반 조회.
   *
   * 센터 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerFindById$Response(params: CenterNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
    return centerNoticeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 ID 기반 조회.
   *
   * 센터 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerFindById(params: CenterNoticeControllerFindById$Params, context?: HttpContext): Observable<CenterNoticeDto> {
    return this.centerNoticeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeDto>): CenterNoticeDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerDelete()` */
  static readonly CenterNoticeControllerDeletePath = '/api/center-notice/center/{id}';

  /**
   * 센터 공지사항 삭제.
   *
   * 센터 공지사항을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerDelete$Response(params: CenterNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
    return centerNoticeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 삭제.
   *
   * 센터 공지사항을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerNoticeControllerDelete(params: CenterNoticeControllerDelete$Params, context?: HttpContext): Observable<CenterNoticeDto> {
    return this.centerNoticeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeDto>): CenterNoticeDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerUpdate()` */
  static readonly CenterNoticeControllerUpdatePath = '/api/center-notice/center/{id}';

  /**
   * 센터 공지사항 수정.
   *
   * 센터 공지사항을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerUpdate$Response(params: CenterNoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
    return centerNoticeControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 수정.
   *
   * 센터 공지사항을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerUpdate(params: CenterNoticeControllerUpdate$Params, context?: HttpContext): Observable<CenterNoticeDto> {
    return this.centerNoticeControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeDto>): CenterNoticeDto => r.body)
    );
  }

  /** Path part for operation `centerNoticeControllerUpdateOrder()` */
  static readonly CenterNoticeControllerUpdateOrderPath = '/api/center-notice/center/order';

  /**
   * 센터 공지사항 순서 수정.
   *
   * 센터 공지사항의 순서를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerNoticeControllerUpdateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerUpdateOrder$Response(params: CenterNoticeControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerNoticeControllerUpdateOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 순서 수정.
   *
   * 센터 공지사항의 순서를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerNoticeControllerUpdateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerNoticeControllerUpdateOrder(params: CenterNoticeControllerUpdateOrder$Params, context?: HttpContext): Observable<boolean> {
    return this.centerNoticeControllerUpdateOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `parentCenterNoticeControllerCountByParent()` */
  static readonly ParentCenterNoticeControllerCountByParentPath = '/api/center-notice/parent/count';

  /**
   * 내 아동의 센터 공지사항 개수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCenterNoticeControllerCountByParent()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerCountByParent$Response(params?: ParentCenterNoticeControllerCountByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return parentCenterNoticeControllerCountByParent(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 아동의 센터 공지사항 개수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCenterNoticeControllerCountByParent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerCountByParent(params?: ParentCenterNoticeControllerCountByParent$Params, context?: HttpContext): Observable<number> {
    return this.parentCenterNoticeControllerCountByParent$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `parentCenterNoticeControllerSearchCursor()` */
  static readonly ParentCenterNoticeControllerSearchCursorPath = '/api/center-notice/parent/search/cursor';

  /**
   * 센터 공지사항 커서 기반 조회.
   *
   * 센터 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCenterNoticeControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerSearchCursor$Response(params: ParentCenterNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeSearchResponseDto>> {
    return parentCenterNoticeControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 커서 기반 조회.
   *
   * 센터 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCenterNoticeControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerSearchCursor(params: ParentCenterNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<CenterNoticeSearchResponseDto> {
    return this.parentCenterNoticeControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeSearchResponseDto>): CenterNoticeSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `parentCenterNoticeControllerFindById()` */
  static readonly ParentCenterNoticeControllerFindByIdPath = '/api/center-notice/parent/{id}';

  /**
   * 센터 공지사항 ID 기반 조회.
   *
   * 센터 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCenterNoticeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerFindById$Response(params: ParentCenterNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
    return parentCenterNoticeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공지사항 ID 기반 조회.
   *
   * 센터 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCenterNoticeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCenterNoticeControllerFindById(params: ParentCenterNoticeControllerFindById$Params, context?: HttpContext): Observable<CenterNoticeDto> {
    return this.parentCenterNoticeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterNoticeDto>): CenterNoticeDto => r.body)
    );
  }

}
